import {DateBaseAttribute, DateBaseAttributeOptions} from './DateBaseAttribute';

export type DateTimeAttributeOptions = DateBaseAttributeOptions;

export class DateTimeAttribute extends DateBaseAttribute {
  constructor(options: DateTimeAttributeOptions = {}) {
    super(options);
  }

  get inputType(): string {
    return 'datetime';
  }
}
